import dayjs from 'dayjs';
import { UiDivider, UiText, UiTitle } from 'znanie-uikit';

import HtmlContent from 'components/common/HtmlContent';
import ContentSpeakersAvatars from 'components/widget/ContentSpeakersAvatars';
import ShareContent, { SocialSlug } from 'components/common/ShareContent';

import { ContentType, SpeakerType } from 'graphql/types';

import css from './VideoInfo.module.scss';

interface IProps {
  data: ContentType;
}

export default function VideoInfo({ data }: IProps) {
  return (
    <div className={css.block}>
      <UiTitle className={css.videoName} weight="normal" size="big" as="h1">
        {data.title}
      </UiTitle>
      <div className={css.wrapper}>
        <div className={css.videoInformation}>
          <ContentSpeakersAvatars
            speakers={(data.speakers as SpeakerType[]) || []}
            usageMode="full"
          />
          <UiText
            className={css.videoDescription}
            as="p"
            size="small_plus"
            weight="normal"
          >
            {data.description}
          </UiText>
          <UiText className={css.videoDate} size="small" weight="normal">
            {dayjs(data.created).format('DD MMMM YYYY')}
          </UiText>
        </div>
        <ShareContent title="Поделись этим видео" socials={[SocialSlug.VK]} />
      </div>
      <UiDivider />
      {data.body && (
        <div>
          <UiTitle as="h3">Конспект</UiTitle>
          <HtmlContent html={data.body as string} truncate />
        </div>
      )}
    </div>
  );
}
